import { configureStore } from '@reduxjs/toolkit'
import ModalSlice from './slices/ModalSlice'
import LoadingSlice from './slices/LoadingSlice'

export const store = configureStore({
reducer: {
    displayModal: ModalSlice,
    displayLoading: LoadingSlice,
}
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
